// extracted by mini-css-extract-plugin
export default {"mt-8px":"ChangedNumber_mt-8px__75BkP","actions":"ChangedNumber_actions__tR9LI"};